export default "__VITE_ASSET__C4kNr8dV__"